import { render, staticRenderFns } from "./OtherArticle.vue?vue&type=template&id=8f09172e&scoped=true"
import script from "./OtherArticle.vue?vue&type=script&lang=js"
export * from "./OtherArticle.vue?vue&type=script&lang=js"
import style0 from "./OtherArticle.vue?vue&type=style&index=0&id=8f09172e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f09172e",
  null
  
)

export default component.exports